/*
 * サブシステム名：運用
 * 機能名：ログイン
 */

<template>
  <v-form style="height: 100vh">
    <v-container class="pa-0 ma-0" fluid fill-height>
      <v-card class="mx-auto" min-width="25vw" min-height="350px" style="border-radius: 10px;">
        <v-card-text>
        <v-row no-gutters justify="center">
          <v-img src="@/assets/ddlogo.png" min-width="22vw" max-width="25vw" max-height="10vh" contain class="mt-3"></v-img>
        </v-row>
        <v-row no-gutters justify="center">
          <v-divider class="py-2"></v-divider>
        </v-row>
        <v-row no-gutters v-show="isMultiCompanyMode === true">
          <v-col :cols="12" class="px-5">
            <dd-text-box
              label="会社コード"
              ref="kaishaCd"
              v-model="kaishaCd"
              prepend-icon="mdi-home"
              :length="12"
              :required="true"
              :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
            />
          </v-col>
        </v-row>
        <v-row no-gutters v-show="isMultiCompanyMode === true">
          <v-col :cols="12" class="pl-11 mb-4">
            <dd-checkbox
              label="会社コードを記憶する"
              v-model="registKaishaCd"
            />
          </v-col>
        </v-row>
        <div class="mt-1" />
        <v-row no-gutters>
          <v-col :cols=12 class="px-5">
            <dd-text-box
              label="ユーザID"
              ref="jininCd"
              v-model="jininCd"
              prepend-icon="mdi-account-circle"
              :length="25"
              :required="true"
              :valueType="Ctrls.InputTypes.Alphanumeric"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12 class="pl-11 mb-4">
            <dd-checkbox
              label="ユーザIDを記憶する"
              v-model="registUserId"
            />
          </v-col>
        </v-row>
        <div class="mt-1" />
        <v-row no-gutters>
          <v-col :cols=12 class="px-5">
            <dd-password-box
              ref="password"
              label="パスワード"
              v-model="password"
              :required="true"
              :valueType="Ctrls.InputTypes.Alphanumeric"
              :append-icon="currentpassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="currentpassword ? 'text' : 'password'"
              @click:append="currentpassword = !currentpassword"
              prepend-icon="mdi-lock-outline"
              dense
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12 class="pl-11 mb-4">
              <dd-checkbox
              label="パスワードを記憶する"
              v-model="registPassword"
            />
          </v-col>
        </v-row>
        <div class="mt-1" />
        <v-row no-gutters>
          <v-col :cols=12 class="px-4">
            <dd-login-button
              :isLoading="isLoading"
              class="py-2"
              :block=true
              max-height="10vh"
              @click="onClick">
              ログイン
            </dd-login-button>
          </v-col>
        </v-row>
        <div class="mt-1" />
        <!--
        <v-row no-gutters class="pt-2 pb-1" justify="center">
          <a
            style="font-size:0.75rem;color:blue !important;"
            @click="onLoginInfoInquiryClick">
            管理者のユーザIDまたはパスワードをお忘れの場合はこちら
          </a>
        </v-row>
        -->
        <!--
        <v-row no-gutters justify="end">
          <div class="version-text px-5">Ver.2.0.20230228.0</div>
        </v-row>
        -->
        </v-card-text>
        <v-divider class="py-0"></v-divider>
        <v-card-actions class="py-1 px-0">
          <v-row no-gutters justify="center">
            <v-chip v-if="![undefined, null, ''].includes(getExLinkURL('external_link_1'))" small label pill color="#FFF" :href="getExLinkURL('external_link_1')" target="_blank">
              <span class="link-text">{{ getExLinkTitle('external_link_1') }}</span>
            </v-chip>
            <v-chip v-if="![undefined, null, ''].includes(getExLinkURL('external_link_2'))" small label pill color="#FFF" :href="getExLinkURL('external_link_1')" target="_blank">
              <span class="link-text">{{ getExLinkTitle('external_link_2') }}</span>
            </v-chip>
            <v-chip v-if="![undefined, null, ''].includes(getExLinkURL('external_link_3'))" small label pill color="#FFF" :href="getExLinkURL('external_link_1')" target="_blank">
              <span class="link-text">{{ getExLinkTitle('external_link_3') }}</span>
            </v-chip>
            <v-chip v-if="![undefined, null, ''].includes(getExLinkURL('external_link_4'))" small label pill color="#FFF" :href="getExLinkURL('external_link_1')" target="_blank">
              <span class="link-text">{{ getExLinkTitle('external_link_4') }}</span>
            </v-chip>
            <v-chip v-if="![undefined, null, ''].includes(getExLinkURL('external_link_5'))" small label pill color="#FFF" :href="getExLinkURL('external_link_1')" target="_blank">
              <span class="link-text">{{ getExLinkTitle('external_link_5') }}</span>
            </v-chip>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-form>
</template>
<script>
// import DdDefaultButton from '@/components/DdDefaultButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdTextBox from '@/components/DdTextBox'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'
import viewMixins from '@/mixins/viewMixins'
import DdPasswordBox from '@/components/DdPasswordBox'
import DdLoginButton from '@/components/DdLoginButton'
import messages from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
const q = new URLSearchParams(window.location.search)
if (!q.has('t')) {
  const ts = date.getCurrentDate().replaceAll('/', '') + date.getCurrentTime().replaceAll(':', '')
  window.location.href = window.location.href + '/?t=' + ts
}

export default {
  name: 'Login',
  mixins: [
    viewMixins
  ],
  components: {
    DdPasswordBox,
    DdLoginButton,
    DdCheckbox,
    DdTextBox
  },
  data: () => ({
    kaishaCd: '',
    jininCd: '',
    password: '',
    startPage: 'ddboard',
    registKaishaCd: false,
    registUserId: false,
    registPassword: false,
    currentpassword: false,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      registerdKaishaCd: 'usersBeforeLogin/kaishaCd',
      registerdUserid: 'usersBeforeLogin/userId',
      registerdPassword: 'usersBeforeLogin/password',
      msyssystemconfig: 'DDMasters/msysSystemConfig'
    }),
    isMultiCompanyMode: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'multi_company_mode'
      })
      if (ret.length > 0 && ret[0].configValue1 === '1') {
        return true
      }
      return false
    }
  },
  created () {
    // systemconfigは常に再取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['msyssystemconfig'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['msyssystemconfig'], version: 1, kinoId: 0 }).then(() => {
        this.$store.dispatch('users/flushUserInfo')
        this.$store.dispatch('system/setViewTitle', 'ログイン')
        this.$store.dispatch('DDMasters/loadMasters', { list: ['msysmessage'], version: 1 })
        this.$store.dispatch('DDMasters/restoreMasters')
        this.setDefaultCompanyCode()
      })
    })
  },
  mounted () {
    const self = this
    self.logger = new Logger('token', 'name')
    self.logger.debug('Login.mounted', { loginId: self.loginId, password: self.password })
    // systemconfigは常に再取得
    self.$store.dispatch('DDMasters/truncateMasters', { list: ['msyssystemconfig'] }).then(() => {
      self.$store.dispatch('DDMasters/loadMasters', { list: ['msyssystemconfig'], version: 1, kinoId: 0 }).then(() => {
        self.$store.dispatch('usersBeforeLogin/loadDatas').then(() => {
          if (self.registerdKaishaCd !== '') {
            self.registKaishaCd = true
            self.kaishaCd = self.registerdKaishaCd
          }
          if (self.registerdUserid !== '') {
            self.registUserId = true
            self.jininCd = self.registerdUserid
          }
          if (self.registerdPassword !== '') {
            self.registPassword = true
            self.password = self.registerdPassword
          }
          self.isLoading = false
          effects.loadComplete()
        }).catch()
      })
    })
    // loadMasters: ['msysmessage']
  },
  methods: {
    onClick: function () {
      console.log('onClick', this.msyssystemconfig)
      this.$store.dispatch('system/clearMessage')
      const isvalid = this.validateAll(this.$refs)
      console.log('validated', isvalid, this.$refs)
      const self = this
      this.setDefaultStartPage().then(() => {
        if (!isvalid) { return }
        effects.loadStart()
        self.isLoading = true
        console.log('post')

        // うさなびコードからの変換ロジックを別途実装
        let LoginKaishaCode = '0010'

        const multiCompanyLoginSettings = this.msyssystemconfig.filter(function (elem) {
          return elem.configName === 'multi_company_login_mode'
        })
        if (multiCompanyLoginSettings.length > 0 && multiCompanyLoginSettings[0].configValue1 === '1') {
          LoginKaishaCode = self.kaishaCd
        }
        let postUrl = '/api/v1/mstjinin/trylogin'
        let trialMode = false
        const trialModeSettings = this.msyssystemconfig.filter(function (elem) {
          return elem.configName === 'trial_mode'
        })
        if (trialModeSettings.length > 0 && trialModeSettings[0].configValue1 === '1') {
          postUrl = '/api/v1/mstUsanaviKokyaku/TryLoginForUsaLite'
          trialMode = true
        }

        self.HttpClient.post(postUrl, {
          jininCd: self.jininCd,
          password: self.password,
          kaishaCd: LoginKaishaCode
        })
          .then((data) => {
            console.log('login', data, data.isValid, data.isExistsPayload)

            if (!data.isValid || !data.isExistsPayload) {
              if (trialMode && data.payload) {
                if (data.payload.riyoStatusKbn === '12' || data.payload.riyoStatusKbn === '13') {
                  self.$router.push('riyokiyaku/' + data.payload.id)
                  self.isLoading = false
                  effects.loadComplete()
                  return
                }
              }
              console.log('login error route', data.summaryMessage)
              self.setInvalidMessage(self.$refs, data.invalidList)
              modals.showToastMessage(data.summaryMessage.messageCd, null, 800, null, 'info')
              self.isLoading = false
              effects.loadComplete()
              return
            }
            console.log('login ok clear message')
            self.$store.dispatch('system/clearMessage')
            console.log('login ok get user info')
            const userInfo = data.payload.loginInfo
            console.log('loginInfo', userInfo)
            userInfo.faceImage = data.payload.mstFaceImage || {}
            console.log('faceImage', userInfo.faceImage)

            self.$store.dispatch('users/tryLogin', userInfo).then(() => {
              self.$store.dispatch('DDMasters/saveMasters', data.payload).then(() => {
                let saveKaishaCd = ''
                let saveUserId = ''
                let savePassword = ''

                if (self.registUserId) {
                  saveKaishaCd = self.kaishaCd
                }

                if (self.registUserId) {
                  saveUserId = self.jininCd
                }
                if (self.registPassword && userInfo.kariPasswordLoginFlg === false) {
                  savePassword = self.password
                }
                // 入力されたuid,パスワードをindexedDbに保存
                self.$store.dispatch('usersBeforeLogin/saveDatas', { kaishaCd: saveKaishaCd, userId: saveUserId, password: savePassword }).then(() => {
                  if (userInfo.kariPasswordLoginFlg === false) {
                    if (self.errorLocation && self.errorLocation.length > 0) {
                      const nextSharpNum = self.errorLocation.indexOf('#') + 1
                      var route = self.errorLocation.substring(nextSharpNum)
                      // const index = route.indexOf('/?t=')
                      // if (index > 1) {
                      //   route = route.substring(0, index)
                      // }
                      if (route !== '/') {
                        self.$router.push(route)
                      } else {
                        self.$router.push('/' + self.startPage)
                      }
                      self.$store.dispatch('users/setGoingToUrl', { url: '' })
                      // location.href = self.errorLocation
                    } else {
                      self.$router.push('/' + self.startPage)
                    }
                  } else {
                    self.isLoading = false
                    effects.loadComplete()
                    self.$router.push('password/edit/' + userInfo.id)
                  }
                })
              })
            })
          }).catch(function (error) {
            const m = messages.getInfo('COME0001')
            self.$store.dispatch('system/setMessage', m)
            console.log('post error')
            console.log(error)
            effects.loadComplete()
          })
      })
    },
    setDefaultCompanyCode: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'default_kaisha_cd'
      })
      if (ret.length > 0 && ret[0].configValue1 !== '') {
        this.kaishaCd = ret[0].configValue1
      } else {
        this.kaishaCd = '0010'
      }
    },
    setDefaultStartPage: function () {
      return new Promise(resolve => {
        const ret = this.msyssystemconfig.filter(function (elem) {
          return elem.configName === 'default_start_page'
        })
        if (ret.length > 0 && ret[0].configValue1 !== '') {
          this.startPage = ret[0].configValue1
        } else {
          this.startPage = 'ddboard'
        }
        resolve()
      })
    },
    onLoginInfoInquiryClick: function () {
      this.$router.push('/loginInfoInquiry')
    },
    // うさnavi顧客コードの入力補助
    inputUsanaviKokyakuCd: function () {
      if (this.usanaviKokyakuCd.length === 6) {
        this.usanaviKokyakuCd = this.usanaviKokyakuCd + '-'
      }
    },

    // 外部リンク情報取得
    getExLinkTitle: function (configName) {
      const ret = this.msyssystemconfig.filter(function (elem) {
        // return elem.kaishaCd === '****' && elem.configName === configName && elem.delFlg === false
        return elem.configName === configName && elem.delFlg === false
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    getExLinkURL: function (configName) {
      const ret = this.msyssystemconfig.filter(function (elem) {
        // return elem.kaishaCd === '****' && elem.configName === configName && elem.delFlg === false
        return elem.configName === configName && elem.delFlg === false
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    }
  }
}
</script>
<style scoped>
.version-text {
  font-size: small;
  font-family: Verdana;
  font-weight: bold;
}
::v-deep .v-text-field.v-text-field--solo.v-input--dense .v-input__prepend-outer {
    margin-top: 4px;
    margin-right: 4px;
}
::v-deep .v-input__prepend-outer .v-icon {
  color: #2D71BF !important;
}
.link-text {
  color: #4682b4 !important;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
